import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-17/task-01";

const task: Slide = {
  titleHtml:
    "A condenser microphone is designed with an opening in the housing. This opening can be<br>considered as an acoustic mass, while the inside of the housing is considered as an acoustic<br>compliance. A fibrous material is added to achieve a predominantly resistive behaviour.<br>Which of the following combinations can be used to achieve a cardioid directivity?",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
